import classNames from 'classnames';
import { Icon, SvgAnimation } from '@/components/standalone';
import { useRef } from 'react';
import useOnScreen from '@/helpers/useOnScreen';
import styles from '@/styles/personae.module.scss';

function PlatformsComposabilitySection() {
  const headingRef = useRef();
  const { isOnScreen: isHeadingOnScreen } = useOnScreen({
    ref: headingRef,
    threshold: 0.3,
    rootMargin: '0px',
    isOnce: true,
  });

  const animationRef = useRef();
  const { isOnScreen: isAnimationOnScreen } = useOnScreen({
    ref: animationRef,
    threshold: 0.5,
    rootMargin: '0px',
    isOnce: true,
  });

  return (
    <div
      className={classNames(
        'section',
        styles.personaeSection,
        styles.personaeSectionComposability,
      )}
    >
      <div className={classNames('max-content-width', styles.invert)}>
        <div ref={animationRef} className={styles.personaeSectionAnimation}>
          <SvgAnimation
            name="Composability"
            autoplay={isAnimationOnScreen}
            onComplete={(animation) => {
              animation.playSegments(
                [1.68 * 60, animation.getDuration() * 60],
                true,
              );
              // eslint-disable-next-line no-param-reassign
              animation.loop = true;
            }}
          />
        </div>
        <div
          className={classNames(styles.personaeSectionText, {
            [styles.personaeSectionTextAppear]: isHeadingOnScreen,
          })}
          ref={headingRef}
        >
          <div className="tb-tag">
            <Icon name="Grid2x2Check" />
            COMPOSABILITY
          </div>
          <h2>Make your protocol truly composable</h2>
          <p>
            You can use Trustblock directly in your contracts to access security
            and trust data to make your protocol truly composable and reactive
            to major security events. <br />
            Protect the funds of your defi and lending pools, setup
            secured-by-default DEX or ICO protocols, build dynamic insurance
            protocols and much more.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PlatformsComposabilitySection;
